import request from '@/config/axios'

export interface CircleOrderVO {
  tradeOrderId?: number
  tradeOrderNo?: string
  payOrderId?: number
  bizType?: string
  title?: string
  amount?: number
  userId?: number
  tradeStatus?: number
  payStatus?: boolean
  paidTime?: string
  createTime?: string
  applyId?: number
  ownerStatus?: number
  circleId?: number
  circleName?: string
  joinPayStatus?: number
  targetUserId?: number
  pathLength?: number
  unlockPayStatus?: number
}

export const getCircleOrderPage = (
  params: PageParam & {
    bizType?: string
    userId?: number
    circleId?: number
    targetUserId?: number
    payStatus?: boolean
  }
) => request.get({ url: '/bosscircle/circle/order/page', params })
